<template>
	<div class="container">

		<template v-if="fetchDone">

			<div class="text-center" style="font-size: 18pt;margin-bottom: 20px;">
				<p v-if="currentSubscription && currentSubscription.is_active == 1 && currentSubscription.type != 'Trial'">{{$store.company.company_name}} is currently subscribed to:</p>

				<div v-else-if="subscriptionIsCurrent && (currentSubscription.is_active == 0 || currentSubscription.type != 'Trial')" class="text-danger">
					{{$store.company.company_name}}'s current subscription will expire on {{formatDate(currentSubscription.expiry)}}
				</div>
				<div v-else-if="subscriptionIsCurrent && currentSubscription.type == 'Trial'" class="text-danger">
					{{$store.company.company_name}}'s trial period will expire on {{formatDate(currentSubscription.expiry)}}
				</div>
				<div v-else-if="'expiry' in currentSubscription && !subscriptionIsCurrent" class="text-danger">
					{{$store.company.company_name}}'s current subscription has expired
				</div>

				<p v-else>Choose one of the following subscriptions:</p>
			</div>

			<subscription-package
				v-for="(plan,index) in plans"
				v-if="!subscriptionIsCurrent || currentSubscription.is_active == 0 || currentSubscription.plan_level == index+1 || showAll || currentSubscription.type == 'Trial'"
				:title="plan.name+' - up to '+mutateUpto(plan.user_limit)+' users'"
				:header-color="planColors[index]"
				:monthly-price="plan.price_monthly"
				:plan-id="plan.stripe_plan_id"
				:current-subscription="currentSubscription"
				:plan-level="index+1"
				:key="index"
				:subscription-is-current="subscriptionIsCurrent"
				v-on:subscriptionChange="fetchCurrentSubscription">

				<ul>
					<li>Full feature set</li>
					<li>Upgrade any time</li>
					<li>No committment</li>
					<li>Good for a company of up to {{mutateUpto(plan.user_limit)}} people</li>
				</ul>
			</subscription-package>

			<p class="text-center" v-if="!showAll">
				<a href="#" v-on:click.prevent="showAll = true">Upgrade/Downgrade...</a>
			</p>

			<div class="card" v-if="subscriptionIsCurrent && currentSubscription.type != 'Trial'">
				<div class="card-header">Card Details</div>
				<div class="card-body">

					<p class="text-center">
						<strong v-if="currentSubscription.card_last_4">{{currentSubscription.card_brand}} **** {{currentSubscription.card_last_4}}</strong><br>
						<span v-if="currentSubscription.card_expiry">Expires {{currentSubscription.card_expiry}}</span>
					</p>

					<div class="text-center">
						<stripe-button
							:email="$store.userDetails.email"
							name="Update Card"
							description="Update your credit card"
							label="Update Card"
							button-label="Update"
							:process-route="$store.apiRoot+'api/Subscription/update-card?token='+$store.sessionToken">

							<input type="hidden" name="error_redirect" :value="redirectError">
							<input type="hidden" name="redirect" :value="redirectThankyou">

						</stripe-button>
					</div>
				</div>
			</div>

		</template>

		<modal-dialog :modal-visible="errorModal.visible"
			title="Error"
			:submit-visible="false"
			cancel-button-text="Ok"
			v-on:closeModal="errorModal.visible = false">

			<div class="text-danger text-center">
				{{errorModal.message}}
			</div>

		</modal-dialog>

	</div>
</template>
<script type="text/javascript">
import SubscriptionPackage from "./subscription/SubscriptionPackage"
import StripeButton from "@/components/StripeButton"
import ModalDialog from "@/components/ModalDialog"

export default {
	name: "Subscription",
	components: {
		SubscriptionPackage,
		StripeButton,
		ModalDialog
	},
	props: [
		"redirectThankyouCustom",
		"redirectErrorCustom"
	],
	watch: {
		redirectErrorCustom() {
			this.redirectError = this.redirectErrorCustom
		},
		redirectThankyouCustom() {
			this.redirectThankyou = this.redirectThankyouCustom
		}
	},
	data() {
		return {
			redirectThankyou: "https://"+window.location.hostname+(window.location.port ? ':'+window.location.port: '')+"/settings/tradetraks-subscription",
			redirectError: "https://"+window.location.hostname+(window.location.port ? ':'+window.location.port: '')+"/settings/tradetraks-subscription/error",
			currentSubscription: {},
			fetchDone: false,
			showAll: true,
			errorModal: {
				visible: false,
				message: ""
			},
			plans: [],
			environment: window.environment
		}
	},
	computed: {
		planColors() {
			let red = 186, green = 170, blue = 255
			let colors = []

			for (var i = 0; i < 5; i++) {
				red *= 0.9
				green *= 0.9
				blue *= 0.95

				colors.push("rgb("+red+","+green+","+blue+")")
			}

			return colors
		},
		subscriptionIsCurrent() {
			//this.currentSubscription.expiry = "2022-01-01"
			if ("expiry" in this.currentSubscription) {
				if (this.moment(this.currentSubscription.expiry).isAfter(this.moment()))
					return true
			}
			return false
		}
	},
	methods: {
		updateCard() {

		},
		mutateUpto(upto) {
			if (upto > 998)
				return "unlimited"
			else
				return upto
		},
		fetchCurrentSubscription() {
			let vm = this

			vm.spinner(true)

			this.getJSON("Subscription/get",{},true).then(response => {
				if (response.success && response.data.length > 0) {
					vm.currentSubscription = response.data[0]
					vm.$store.subscription = response.data[0]
					vm.showAll = false
				}
				vm.fetchDone = true
				vm.spinner(false)
			})
		},
		fetchPlans() {
			let vm = this

			this.getJSON("Subscription/plans").then(response => {
				if (response.success)
					vm.plans = response.data
			})
		}
	},
	created() {
		window.location = window.apiRoot + "outbound/subscription/" + this.$store.company.slug + "/" + this.$store.sessionToken

		this.fetchPlans()
		this.fetchCurrentSubscription()

		this.setSessionToken() //reports from support personnel that Subscription/create?token= endpoint is throwing "Token or Api key not valid" error, so make sure we're working with a fresh security token

		if (this.redirectThankyouCustom)
			this.redirectThankyou = this.redirectThankyouCustom

		if (this.redirectErrorCustom)
			this.redirectError = this.redirectErrorCustom

		if ("error_message" in this.$route.params) {
			this.errorModal.visible = true
			this.errorModal.message = this.$route.params.error_message
		}
	}
}
</script>
